module.exports = __webpack_public_path__ + "static/media/oxytocin.3f8a7fc0.png";